import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import SODAuthorizedFilers from '../../container/modules/companyMngmt/authorizedFilers';

const NotFound = lazy(() => import('../../container/pages/404'));
const CompanyList = lazy(() => import('../../container/modules/companyMngmt/list'));
const CompanyView = lazy(() => import('../../container/modules/companyMngmt/view'));
const SubmissionsList = lazy(() => import('../../container/modules/submissions/list'));
const SubmissionsView = lazy(() => import('../../container/modules/submissions/view'));

function SODPagesRoute() {
  return (
    <Routes>
      <Route path="authorized-filers/*" element={<SODAuthorizedFilers />} />
      <Route path="*" element={<NotFound />} />
      <Route path="companies-list" element={<CompanyList />} />
      <Route path="companies-view" element={<CompanyView />} />
      <Route path="submissions-list" element={<SubmissionsList />} />
      <Route path="submissions-view" element={<SubmissionsView />} />
    </Routes>
  );
}

export default SODPagesRoute;
